<template>
    <a-drawer :wrapClassName="drawerWrapClass" placement="bottom" :height="'auto'" :closable="false" :destroyOnClose="true" @close="onClose" :visible="visible">
        <div class="flex justify-end">
            <a href="javascript:void(0)" @click="doNotSetCookie()" class="block hover:bg-gray-200 rounded-full p-1">
                <svg xmlns='http://www.w3.org/2000/svg' class='fill-current text-gray-800 rounded-full' viewBox='0 0 512 512'  height="32" width="32"><title>Close</title><path fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M368 368L144 144M368 144L144 368'/></svg>
            </a>
        </div>
        <div class="flex flex-col gap-3">
            <div class="font-medium text-md">
                {{  this.$root.getLangText(cookie.title) == '' ? cookie.title['en'] : this.$root.getLangText(cookie.title) }}
            </div>
            <div class="text-sm text-gray-500">{{  this.$root.getLangText(cookie.descr) == '' ? cookie.descr['en'] : this.$root.getLangText(cookie.descr) }}</div>
            <div class="flex justify-between items-center cookie-banner-actions">
                 <a class="text-gray-500 underline" @click="doNotSetCookie()">{{  this.$root.getLangText(cookie.button_not_accept) == '' ? cookie.button_not_accept['en'] : this.$root.getLangText(cookie.button_not_accept) }}</a>
                <button type="button" @click="setCookie()" class="text-white bg-black hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center">
                    {{  this.$root.getLangText(cookie.button_accept) == '' ? cookie.button_accept['en'] : this.$root.getLangText(cookie.button_accept) }}
                </button>
            </div>
        </div>
    </a-drawer>    
</template>

<script>
export default {
    name: 'AppBottomPrivacyCookie',


	data() {
		return {
            visible: this.$root.shouldShowCookieBanner(),
            cookie: {
                title: {
                    en: 'This site uses cookies and services to collect technical data from visitors to ensure performance and improve the quality of service.', 
                    ru: 'Этот сайт использует файлы cookies и сервисы сбора технических данных посетителей для обеспечения работоспособности и улучшения качества обслуживания.',
                    pl: 'Ta strona używa plików cookies dla zbierania technicznych danych użytkowników w celu zapewnienia wydajności divalności witryny oraz polepszenia jakości obsługi.',
                },
                descr: {
                    en: 'By clicking the "Accept" button, you agree to this.',
                    ru: 'Нажимая кнопку "Принять", вы соглашаетесь с этим.',
                    pl: 'Poprzez kliknięcie „Akceptuję”, wyrażasz na to zgodę.'
                },
                button_detail: {
                    en: 'Detailed information',
                    ru: 'Детальная информация',
                },
                button_accept: {
                    en: 'Accept all',
                    ru: 'Принять все',
                    pl: 'Akceptuję wszystkie pliki cookies'
                },
                button_not_accept: {
                    en: 'Do not use',
                    ru: 'Не использовать',
                    pl: 'Nie używać'
                },                
                page: {
                    en: "<div><h3>1. Introduction: Cookies are used on this website</h3><p>By using this website, you consent to the processing of cookies, user data (location information; OS type and version; browser type and version; device type and screen resolution; source from where the user went to the site; from which site or through which advertisement; OS and Browser language; which pages opens and which buttons the user clicks on; ip address) for the purposes of website operation, retargeting and statistical research and reviews. If you do not want your data to be processed, you must leave this site.advertising; OS and Browser language; which pages are opened and which buttons are clicked by the user; ip address)</p><h3>2. About cookies</h3><p>Cookies are used on this website. A cookie is a small, simple file (a string of letters and numbers) that is sent along with the pages of a website and stored by the browser on your computer's hard drive. On subsequent visits, the information from this file can be sent back to our servers.</p><p>Web servers can use cookies to identify and track users when browsing various pages of a website, as well as determine whether they have visited it before.</p><h3>3. Cookies and personal data</h3><p>The cookies that we store through our website do not contain any information that allows us to identify you.</p><h3>4.Enabling, disabling and deleting cookies</h3><p>More detailed information about enabling, disabling and deleting cookies can be found in the instructions for your browser or in its help.</p><h3>5.Additional information about cookies</h3><p>More information about cookies can be found on <a href='https://ru.wikipedia.org/wiki/Cookie'>Wikipedia</a>, or other websites.</p></div>",
                    ru: "<div><h3>1. Вступление: на этом веб-сайте используются файлы cookie</h3><p>Используя этот веб-сайт, Вы даете согласие на обработку файлов cookie, пользовательских данных (сведения о местоположении; тип и версия ОС; тип и версия Браузера; тип устройства и разрешение его экрана; источник откуда пользователь перешел на сайт; с какого сайта или по какой рекламе; язык ОС и Браузера; какие страницы открывает и на какие кнопки нажимает пользователь; ip-адрес) в целях функционирования сайта, проведения ретаргетинга и проведения статистических исследований и обзоров. Если Вы не хотите, чтобы Ваши данные обрабатывались, Вы должны покинуть данный сайт.</p><h3>2. О файлах cookie</h3><p>На этом веб-сайте используются файлы cookie. Cookie — это небольшой простой файл (строка из букв и цифр), который отправляется вместе со страницами веб-сайта и сохраняется браузером на жестком диске вашего компьютера. При последующих посещениях информация из этого файла, может быть отправлена обратно на наши серверы.</p><p>Веб-серверы могут с помощью файлов cookie идентифицировать и отслеживать пользователей при просмотре различных страниц веб-сайта, а также определять, посещали ли они его ранее.</p><h3>3. Файлы cookie и персональные данные</h3><p>Файлы cookie, которые мы сохраняем через свой веб-сайт, не содержат каких-либо сведений, позволяющих установить вашу личность.</p><h3>4. Включение, отключение и удаление файлов cookie</h3><p>Более подробную информацию о включении, отключении и удалении файлов cookie можно найти в инструкциях к вашему браузеру или в его справке.</p><h3>5. Дополнительные сведения о файлах cookie</h3><p>Дополнительные сведения о файлах cookie можно найти в <a href='https://ru.wikipedia.org/wiki/Cookie'>Википедии</a>, или других веб-сайтах.</p></div>",
                    pl: "<div><h3>1. Wstęp: Ta witryna wykorzystuje pliki cookie</h3><p>Korzystając z tej witryny, wyrażasz zgodę na przetwarzanie plików cookie, danych użytkownika (informacje o lokalizacji; typ i wersja systemu operacyjnego; typ i wersja przeglądarki; typ urządzenia i rozdzielczość ekranu; źródło, z którego użytkownik przeszedł na stronę; z jakiej strony lub przez jaką reklamę; język systemu operacyjnego i przeglądarki; które strony otwierają i w które przyciski użytkownik klika; adres ip) dla celów divania strony, retargetingu oraz badań i recenzji statystycznych . Jeżeli nie chcesz, aby Twoje dane były przetwarzane, musisz opuścić tę stronę.reklama; Język systemu operacyjnego i przeglądarki; które strony są otwierane i które przyciski są klikane przez użytkownika; adres IP)</p><h3>2. O plikach cookie</h3><p>Na tej stronie używane są pliki cookie. Cookie to mały, prosty plik (ciąg liter i cyfr), który jest wysyłany wraz ze stronami serwisu internetowego i przechowywany przez przeglądarkę na twardym dysku Twojego komputera. Podczas kolejnych odwiedzin informacje z tego pliku mogą być przesyłane z powrotem na nasze serwery.</p><p>Serwery internetowe mogą wykorzystywać pliki cookie do identyfikowania i śledzenia użytkowników podczas przeglądania różnych stron witryny internetowej, a także ustalania, czy odwiedzili oni to wcześniej.</p><h3>3. Pliki cookie i dane osobowe</h3><p>Pliki cookie, które przechowujemy za pośrednictwem naszej witryny, nie zawierają żadnych informacji, które pozwalają nam Cię zidentyfikować.</p><h3>4. Włączanie, wyłączanie i usuwanie plików cookie</h3> <p>Szczegółowe informacje na temat włączania, wyłączania i usuwania plików cookie znajdziesz w instrukcji przeglądarki lub w jej pomocy.</p><h3>5. Dodatkowe informacje o plikach cookie</h3><p>Więcej informacji o plikach cookie pliki cookie można znaleźć na <a href='https://ru.wikipedia.org/wiki/Cookie'>Wikipedia</a> lub na innych stronach internetowych.</p></div>"
                }
            }          
		}
	},

    created() {
    },

    methods: {
        saveCookiePreference(value) {
            try {
                localStorage.setItem('access_cookie', value ? 'true' : 'false');
            } catch (e) {
                // Keep banner closable even if storage is unavailable.
            }
        },

        onClose() {
            this.visible = false;
        },

        setCookie() {
            this.visible = false;
            this.saveCookiePreference(true);
            clearInterval(this.offsetInterval);
        },

        doNotSetCookie() {
            this.visible = false;
            this.saveCookiePreference(false);
            clearInterval(this.offsetInterval);
        },

        updateBannerOffset() {
            const drawer = document.querySelector('.drawer-cookie');
            const wrapper = drawer && drawer.querySelector('.ant-drawer-content-wrapper');
            const content = drawer && drawer.querySelector('.ant-drawer-content');

            if (!wrapper || !content) {
                return;
            }

            // antd nests the scrolling box inside the content
            const scroller = content.querySelector('.ant-drawer-wrapper-body');

            const box = this.getDrawerBox(drawer);
            const bar = this.getNavigationBox();

            let offset = 0;
            let left = 0;
            let width = box.width;

            if (bar) {
                // flush with the bottom of the navigation bar: the banner covers it
                // while it is open, which is what keeps it at the bottom of the screen
                offset = bar.bottom;
                left = bar.left;
                width = bar.width;
            }

            // the banner belongs in the lower part of the screen: never let it be
            // pushed up, and keep it a bar rather than a sheet - a third of the screen
            // at most, long translations scroll inside it instead of growing upwards
            offset = Math.min(Math.max(offset, 0), Math.round(box.height * 0.35));
            width = Math.min(Math.max(width, 0), box.width);
            left = Math.min(Math.max(left, 0), box.width - width);

            const maxHeight = Math.max(Math.round(Math.min(box.height - offset - 16, box.height * 0.34)), 160);

            wrapper.style.setProperty('bottom', offset + 'px', 'important');
            wrapper.style.setProperty('left', left + 'px', 'important');
            wrapper.style.setProperty('width', width + 'px', 'important');
            content.style.setProperty('max-height', maxHeight + 'px', 'important');

            if (scroller) {
                scroller.style.setProperty('max-height', maxHeight + 'px', 'important');
            }
        },

        getNavigationBox() {
            const navigation = document.getElementById('bottom-navigation');

            if (!navigation || !navigation.offsetHeight) {
                return null;
            }

            const navRect = navigation.getBoundingClientRect();
            const bar = this.getNavigationBar(navigation);
            const barRect = bar.getBoundingClientRect();

            return {
                // the bar's bottom edge, as a distance from the bottom of the screen
                bottom: Math.round(navigation.offsetHeight - (barRect.bottom - navRect.top)),
                width: Math.round(barRect.width),
                left: Math.round(barRect.left - navRect.left),
            };
        },

        getDrawerBox(drawer) {
            const rect = drawer.getBoundingClientRect();

            if (rect.height > 0 && rect.width > 0) {
                return rect;
            }

            return {
                top: 0,
                left: 0,
                bottom: window.innerHeight,
                right: window.innerWidth,
                width: window.innerWidth,
                height: window.innerHeight,
            };
        },

        getNavigationBar(navigation) {
            const root = navigation || document.getElementById('bottom-navigation');
            const container = root.firstElementChild;
            const bar = container && container.firstElementChild;

            if (bar && bar.offsetHeight && bar.offsetWidth) {
                return bar;
            }

            if (container && container.offsetHeight && container.offsetWidth) {
                return container;
            }

            return root;
        },

        waitForDrawer(frames = 30) {
            if (document.querySelector('.drawer-cookie .ant-drawer-content-wrapper')) {
                this.updateBannerOffset();

                return;
            }

            if (frames <= 0) {
                return;
            }

            this.waitFrame = window.requestAnimationFrame(() => this.waitForDrawer(frames - 1));
        },

        // the navigation slides in and out while scrolling, so keep the measuring
        // itself off the scroll handler
        scheduleBannerOffset() {
            if (this.offsetFrame) {
                return;
            }

            this.offsetFrame = window.requestAnimationFrame(() => {
                this.offsetFrame = null;
                this.updateBannerOffset();
            });
        },
    },
    watch: {
        visible: {
            handler(val) {
                this.$root.cookieBannerOpen = val;
            },
            immediate: true,
        },
    },
    computed: {
        drawerWrapClass() {
            return this.checkScreen ? 'drawer-custom drawer-custom-first-screen drawer-cookie' : 'drawer-custom drawer-cookie';
        },

        checkScreen() {
            let isMainScreen = true;

            try {
                const mainScreenValue = localStorage.getItem('main-screen');
                isMainScreen = mainScreenValue === 'true' || mainScreenValue === null;
            } catch (e) {
                isMainScreen = true;
            }

            return this.$route.name === 'home'
                && isMainScreen
                && (this.$root.template === 'video_template' || this.$root.template === 'slider_template' || this.$root.template === 'azimut');
        }
    },
    mounted() {
        // ant-design-vue renders the drawer into the body on its own schedule, so keep
        // looking for it until it is there: it has to be placed on the frame it first
        // appears, otherwise it is visibly repositioned afterwards
        this.updateBannerOffset();
        this.$nextTick(this.updateBannerOffset);
        this.waitForDrawer();

        // the navigation menu is loaded from the API, so its bar can still resize, and
        // ant-design-vue recreates the drawer DOM on re-renders, which drops the inline
        // styles with it - re-applying them is idempotent and costs one measurement
        this.offsetInterval = setInterval(this.updateBannerOffset, 250);

        window.addEventListener('resize', this.scheduleBannerOffset);
        window.addEventListener('orientationchange', this.scheduleBannerOffset);
        // capture phase: the page scrolls inside a container on the desktop layout
        document.addEventListener('scroll', this.scheduleBannerOffset, true);
    },

    updated() {
        this.scheduleBannerOffset();
    },

    beforeDestroy() {
        // the banner is gone, so nothing is left to hold announcements back
        this.$root.cookieBannerOpen = false;
        clearInterval(this.offsetInterval);

        if (this.offsetFrame) {
            window.cancelAnimationFrame(this.offsetFrame);
        }

        if (this.waitFrame) {
            window.cancelAnimationFrame(this.waitFrame);
        }

        window.removeEventListener('resize', this.scheduleBannerOffset);
        window.removeEventListener('orientationchange', this.scheduleBannerOffset);
        document.removeEventListener('scroll', this.scheduleBannerOffset, true);
    }
}
</script>
